import { Component, createEffect, createSignal, on } from 'solid-js'
import { FullSprite } from '/common/types/sprite'
import { getRandomBody } from '/web/asset/sprite'
import { RootModal } from '/web/shared/Modal'
import Button from '/web/shared/Button'
import PageHeader from '/web/shared/PageHeader'
import AvatarBuilder from '/web/shared/Avatar/Builder'
import { i18nStore } from '/web/store'

export const SpriteModal: Component<{
  body?: FullSprite
  onChange: (body: FullSprite) => void
  show: boolean
  close: () => void
}> = (props) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  let ref: any

  const [original, setOriginal] = createSignal(props.body)
  const [body, setBody] = createSignal(props.body || getRandomBody())

  createEffect(
    on(
      () => props.body,
      () => {
        if (props.body && !original()) {
          setOriginal(props.body)
        }
      }
    )
  )

  const handleChange = () => {
    props.onChange(body())
  }

  return (
    <RootModal
      show={props.show}
      close={props.close}
      fixedHeight
      maxWidth="half"
      footer={
        <>
          <Button onClick={() => props.onChange(original()!)} schema="secondary">
            {i18n.t.cancel}
          </Button>
          <Button onClick={handleChange}>{i18n.t.confirm}</Button>
        </>
      }
    >
      <PageHeader title={i18n.t.char_characterDesigner} />
      <div class="h-[28rem] w-full text-sm sm:h-[42rem]" ref={ref}>
        <AvatarBuilder body={body()} onChange={(body) => setBody(body)} bounds={ref} noHeader />
      </div>
    </RootModal>
  )
}
